import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { chatConfigured, getChatConfig, getChatAccess } from './chatApi';
import { setChatConnectionSuspended } from './chatHub';
import { setChatEnabled, setChatAttachments } from './redux';
import { withChatBoundary } from './ChatErrorBoundary';

const enabledCheckMs = 5 * 60 * 1000;
const disabledCheckMs = 60 * 1000;

// Изключвателят на чата (`Chat__Enabled` в конфигурацията на сървиса): пита при старт и
// после периодично. Изключен, недостъпен или бавен чат = скрит чат и спряна връзка към хъба — таблетът работи
// без него. Включването се хваща до минута след като чатът отговори пак.
// Чатът е и само за потребителите с фийчъра му в bbs2 (`Chat__Feature`): пита се веднъж, щом чатът е включен —
// фийчър, даден по-късно, се вижда след презареждане.
const ChatSwitch = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!chatConfigured) return undefined;

    let cancelled = false;
    let timer = null;
    let access = null;

    const check = async () => {
      const config = await getChatConfig();
      const switchedOn = !!(config && config.enabled);
      if (switchedOn && access === null) access = await getChatAccess();
      if (cancelled) return;

      const enabled = switchedOn && access === true;
      setChatConnectionSuspended(!enabled);
      dispatch(setChatEnabled(enabled));
      dispatch(
        setChatAttachments(
          enabled && config.attachmentsEnabled
            ? { maxPerMessage: config.maxAttachmentsPerMessage }
            : null
        )
      );
      // Без фийчъра — пак рядко, както при включен чат; неотговорил за фийчъра — след минута.
      timer = setTimeout(check, switchedOn && access !== null ? enabledCheckMs : disabledCheckMs);
    };

    check();
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [dispatch]);

  return null;
};

export default withChatBoundary(ChatSwitch);
